var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 26,
    viewBox: "0 0 96 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0654 5.46973V13.2227H11.2227V11.5957H8.20117V12.7412H1.17871V6.13379H3.02148V8.02637H6.375V6.13379H8.20117V7.46191H11.2227V5.46973H13.0654ZM13.0654 13.8369V17.6885H5.03027V18.834H13.5469V20.2949H3.1875V16.3271H11.2227V15.2812H3.1709V13.8369H13.0654ZM3.02148 11.2803H6.375V9.4375H3.02148V11.2803ZM8.20117 10.1846H11.2227V8.85645H8.20117V10.1846ZM29.2433 17.207V18.7344H15.5304V17.207H21.4406V14.7666H17.1574V9.85254H25.7902V7.99316H17.1242V6.49902H27.6164V11.3135H19.0002V13.2559H27.965V14.7666H23.2668V17.207H29.2433ZM43.512 5.46973V20.4775H41.7357V5.46973H43.512ZM40.4739 5.73535V19.7471H38.7308V15.0156H36.7718C36.2156 16.4932 35.2196 17.3315 33.9495 17.3232C31.9905 17.3398 30.7122 15.2646 30.7122 11.9609C30.7122 8.65723 31.9905 6.61523 33.9495 6.61523C35.2196 6.61523 36.2073 7.44531 36.7718 8.90625H38.7308V5.73535H40.4739ZM33.9495 8.3584C32.97 8.3418 32.389 9.62012 32.4056 11.9609C32.389 14.3018 32.97 15.5801 33.9495 15.5635C34.9456 15.5801 35.5599 14.3018 35.5599 11.9609C35.5599 9.62012 34.9456 8.3418 33.9495 8.3584ZM37.137 10.4004C37.2117 10.8818 37.2532 11.4048 37.2532 11.9609C37.2532 12.5088 37.2117 13.0234 37.1536 13.5049H38.7308V10.4004H37.137ZM59.3081 17.1406V18.6514H45.5952V17.1406H48.7661V13.3389C47.5708 12.6582 46.8486 11.5874 46.8569 10.251C46.8403 7.86035 49.1977 6.2832 52.4184 6.2832C55.6557 6.2832 58.0132 7.86035 58.0132 10.251C58.0132 11.5625 57.3159 12.6167 56.1538 13.3057V17.1406H59.3081ZM52.4184 7.74414C50.1772 7.74414 48.6499 8.69043 48.6665 10.251C48.6499 11.7949 50.1772 12.7578 52.4184 12.7578C54.6596 12.7578 56.2036 11.7949 56.2036 10.251C56.2036 8.69043 54.6596 7.74414 52.4184 7.74414ZM50.5923 17.1406H54.2778V14.0029C53.7051 14.1357 53.0825 14.2021 52.4184 14.2021C51.771 14.2021 51.1567 14.1357 50.5923 14.0195V17.1406Z",
    fill: "#121212"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_609_3336)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.3124 9.31247H80.6874M80.3124 9.68747H80.6874M81 9.5C81 9.77614 80.7761 10 80.5 10C80.2239 10 80 9.77614 80 9.5C80 9.22386 80.2239 9 80.5 9C80.7761 9 81 9.22386 81 9.5Z",
    stroke: "#121212",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3124 9.31247H87.6874M87.3124 9.68747H87.6874M88 9.5C88 9.77614 87.7761 10 87.5 10C87.2239 10 87 9.77614 87 9.5C87 9.22386 87.2239 9 87.5 9C87.7761 9 88 9.22386 88 9.5Z",
    stroke: "#121212",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79 19C79.4167 18 81 16 84 16C87 16 88.5833 18 89 19",
    stroke: "#121212",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84 24C90.0751 24 95 19.0751 95 13C95 6.92487 90.0751 2 84 2C77.9249 2 73 6.92487 73 13C73 19.0751 77.9249 24 84 24Z",
    stroke: "#121212",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_609_3336"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(72 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBad);
export default __webpack_public_path__ + "static/media/bad.cccc90bc79b5d494651b024de4f5594e.svg";
export { ForwardRef as ReactComponent };